/**
 * Проверяет, нужно ли показывать ключи переводов вместо значений.
 * Ищет query параметр `i18n-keys-show=true` в URL.
 *
 * ВАЖНО: Можно отключить через переменную окружения NEXT_PUBLIC_ENABLE_I18N_KEYS_DEBUG=false
 *
 * @param searchParamsOrUrl - URLSearchParams (клиент) или URL string (сервер)
 * @returns true если нужно показывать ключи, false если нужны переводы
 *
 * @example
 * // На клиенте
 * const searchParams = useSearchParams();
 * const showKeys = shouldShowI18nKeys(searchParams);
 *
 * @example
 * // На сервере
 * const referer = headers().get("referer");
 * const showKeys = shouldShowI18nKeys(referer);
 */
export function shouldShowI18nKeys(
  searchParamsOrUrl?: URLSearchParams | string | null
): boolean {
  const envValue = process.env.NEXT_PUBLIC_ENABLE_I18N_KEYS_DEBUG;
  const isEnabled = envValue !== "false";

  if (!isEnabled) {
    return false; // Функционал отключен через env
  }

  if (!searchParamsOrUrl) return false;

  try {
    if (typeof searchParamsOrUrl === "string") {
      // Серверная сторона: парсим URL
      const url = new URL(searchParamsOrUrl, "http://localhost");
      return url.searchParams.get("i18n-keys-show") === "true";
    } else {
      // Клиентская сторона: используем URLSearchParams напрямую
      return searchParamsOrUrl.get("i18n-keys-show") === "true";
    }
  } catch {
    // Если не удалось распарсить URL, возвращаем false
    return false;
  }
}
